import { Component, OnInit } from '@angular/core';
import { CreatePostTemplate } from '../../../models/inModels/PostTemplate';
import { Message } from 'primeng/components/common/message';
import { Router } from '@angular/router';
import { PostTemplateService } from '../../../services/post-template.service';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-post-template-create',
  templateUrl: './post-template-create.component.html',
  styleUrls: ['./post-template-create.component.css']
})
export class PostTemplateCreateComponent implements OnInit {

  model: CreatePostTemplate;
  loading = false;
  error: Message[];
  uploading = false;
  imageIds: string[] = [];

  constructor(
    private router: Router,
    private service: PostTemplateService,
    public storageService: StorageService,
  ) {
    this.model = new CreatePostTemplate();
   }

  ngOnInit() {
  }
  
  goBack(): void {
		this.router.navigate(['/post-templates']);
  }

  save(): void {
		this.loading = true;
    console.log("model", this.model)
    this.model.ImageIds = this.imageIds.join(',');
    console.log("🚀 ~ file: post-template-create.component.ts:39 ~ PostTemplateCreateComponent ~ save ~ this.imageIds.join():", this.imageIds.join())
		this.service.create(this.model).then(
			result => {
				console.log(result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }



	handleImages(event): void {
		var result = this.storageService.handleSuccess(event);
    this.imageIds.push(result.PublicId);
    console.log("🚀 ~ file: post-template-create.component.ts:54 ~ PostTemplateCreateComponent ~ handleImages ~ this.model.ImageIds:", this.imageIds)
		this.loading = false;
	}

  removeImages(imageId: string): void {
		this.imageIds = this.imageIds.filter(x => x != imageId);
	}

  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/post-template/post-template-create/post-template-create.component.ts